module.exports = __webpack_public_path__ + "img/astra.caf6bbd5.png";